export default {
  'footer.copyright': '© {year}. All rights reserved.',
};
